import { Tag } from '@fiverr-private/data_display';

export default Tag;
